<template>
  <div v-if="list.length > 0">
    <div
      v-for="(item, index) in list"
      :key="hash(item)"
      :class="index < list.length - 1 && 'mb-5'"
      class="rounded bg-gray-100 px-5 py-6"
    >
      <TheNuxtLink
        v-if="item.link !== null"
        :to="item.link.url"
        :title="item.name"
        class="block text-sm font-bold hover:text-blue-400"
      >
        {{ item.name }}
        <TheBadge v-if="item.isHot" name="HOT" theme="red" class="ml-1" />
        <TheBadge v-if="item.isNew" name="NEW" theme="orange" class="ml-1" />
        <TheBadge v-if="item.isSuite" name="SUITE" theme="blue" class="ml-1" />
      </TheNuxtLink>

      <div v-if="item.link === null" class="text-base font-bold text-gray-600">
        {{ item.name }}
        <TheBadge v-if="item.isHot" name="HOT" theme="red" class="ml-1" />
        <TheBadge v-if="item.isNew" name="NEW" theme="orange" class="ml-1" />
        <TheBadge v-if="item.isSuite" name="SUITE" theme="blue" class="ml-1" />
      </div>

      <LayoutCNMenuDesktopCategorySubItems :list="item.subMenus" />
    </div>
  </div>
</template>

<script setup lang="ts">
  import hash from 'object-hash';

  import type { IFormatMenu } from '@/stores/menuStore';

  interface IProps {
    list: IFormatMenu[];
  }

  withDefaults(defineProps<IProps>(), {
    list: () => [],
  });
</script>
